import { render } from "./OrderedItemBaseCard.vue?vue&type=template&id=06be647d&scoped=true"
import script from "./OrderedItemBaseCard.vue?vue&type=script&lang=js"
export * from "./OrderedItemBaseCard.vue?vue&type=script&lang=js"

import "./OrderedItemBaseCard.vue?vue&type=style&index=0&id=06be647d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06be647d"]])

export default __exports__